import { jsx as _jsx } from "react/jsx-runtime";
export function Empty({ children }) {
    return (_jsx("div", { className: "py-2", children: _jsx("p", { className: "text-xs leading-5", children: children }) }));
}
